"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const select_1 = __importDefault(require("@kyruus/select"));
const styles_1 = require("../styles");
const useDebouncedValue_1 = __importDefault(require("../../../hooks/useDebouncedValue"));
const SingleSelectTypeaheadFilter = ({ column, showLabel = false, tableId, isLoading = false }) => {
    const { filterValue, setFilter, id, render, minFilterInputLength = 2, minOnFilterOptionsDelay = 500, filterOptions, onFilterOptions, onFilterInputChange, filterOptionsLoading, filterLabel } = column;
    const inputInfo = filterLabel || `Filter by ${render('Header')}`;
    const filterLabelId = `filter-select-label-${tableId}-${id}`;
    const filterId = `filter-select-${tableId}-${id}`;
    // internally track whether a value has been selected
    const [valueSelected, setValueSelected] = react_1.default.useState(false);
    const [searchTerm, setSearchTerm] = react_1.default.useState('');
    // debounce the search term so that we don't fetch filter options too rapidly
    const debouncedSearchTerm = (0, useDebouncedValue_1.default)(searchTerm, minOnFilterOptionsDelay);
    const readyForSearch = searchTerm.length >= minFilterInputLength &&
        searchTerm === debouncedSearchTerm &&
        !valueSelected;
    /**
     * Only fetch filter options when we've met the following criteria:
     *  * search term meets the minimum length requirement
     *  * enough time has passed to satisfy the debounce
     *  * a value is not already selected (for single-select, the value is cleared when the search term changes)
     */
    react_1.default.useEffect(() => {
        if (readyForSearch && typeof onFilterOptions === 'function') {
            onFilterOptions(debouncedSearchTerm);
        }
    }, [debouncedSearchTerm, onFilterOptions, readyForSearch, valueSelected]);
    return (react_1.default.createElement("span", { role: "presentation", onClick: (e) => {
            e.stopPropagation();
        } },
        showLabel ? (react_1.default.createElement(styles_1.FilterLabel, { id: filterLabelId, htmlFor: filterId }, inputInfo)) : (react_1.default.createElement(styles_1.HiddenFilterLabel, { id: filterLabelId, htmlFor: filterId }, inputInfo)),
        react_1.default.createElement(select_1.default, { useTypeahead: true, hideDropdownWhenInputIsEmpty: true, icon: "Search", id: filterId, disabled: isLoading, loading: filterOptionsLoading || !readyForSearch, labelId: filterLabelId, name: filterId, "aria-labelledby": filterLabelId, placeholder: inputInfo, items: filterOptions, selectedItem: filterValue || '', 
            /** return all items from the typeahead response */
            filterItems: () => true, itemToString: (item) => item ? item.label || '' : '', onClear: (clearSelection) => {
                clearSelection();
                setSearchTerm('');
                setValueSelected(false);
            }, inputProps: {
                ['data-testid']: 'single-select-typeahead-filter',
                onClick: (e) => {
                    e.stopPropagation();
                },
                value: searchTerm,
                onChange: (event) => {
                    const value = event.target.value;
                    setSearchTerm(value);
                    setValueSelected(false);
                    if (!value || value.length === 0) {
                        setFilter(undefined);
                    }
                    if (typeof onFilterInputChange === 'function') {
                        onFilterInputChange(value);
                    }
                }
            }, onChange: (selectedItem) => {
                if (selectedItem == null) {
                    setFilter(undefined);
                    setSearchTerm('');
                    setValueSelected(false);
                }
                else {
                    setFilter(selectedItem.value);
                    setSearchTerm(selectedItem.value);
                    setValueSelected(true);
                }
            } })));
};
exports.default = SingleSelectTypeaheadFilter;
//# sourceMappingURL=SingleSelectTypeaheadFilter.js.map